// extracted by mini-css-extract-plugin
module.exports = {"LineDocuments":"styles_LineDocuments__2i4gG","box":"styles_box__1AowL"};